import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/gofore': {
    width: 400,
    height: 512,
    paths: [
      {
        d: 'M324 319.8H310.8V354.5C286.3 377.6 254.5 390.3 220.9 390.3 147.7 390.3 88.5 330.1 88.5 255.9 88.5 181.8 147.7 121.5 220.9 121.5 256.2 121.5 289.5 135.5 314.5 160.9L376.8 97.6C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256 0 378.5 97 480 220.7 480 283.9 480 345.2 453.8 391.7 397.5 389.7 369.9 378.3 319.8 324 319.8zM311.9 207.3H205.6V296.3H324C357.5 296.3 384.5 311.4 400 338.1V307.5C400 242.3 359.6 207.3 311.9 207.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/gofore.js
// module id = Bbk8
// module chunks = 144